// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-icon-button {
  width: 36px;
  height: 36px;
  min-height: 36px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--dark-color-main);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  font-family: inherit;
  transition: background-color 0.2s, color 0.2s;
}
.close-icon-button .bi {
  font-size: 20px;
}
.close-icon-button .bi::before {
  display: block;
  line-height: 1;
  vertical-align: 0;
}
.close-icon-button:hover {
  background: var(--color-bg);
  color: var(--primary-color-main);
}
.close-icon-button:disabled {
  cursor: default;
  color: var(--disabled-font-color);
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/CloseButton.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,6CAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAGI;EACE,cAAA;EACA,cAAA;EACA,iBAAA;AADN;AAKE;EACE,2BAAA;EACA,gCAAA;AAHJ;AAME;EACE,eAAA;EACA,iCAAA;EACA,uBAAA;AAJJ","sourcesContent":["// 閉じる(×)ボタン(運営ツールの外見動画の編集モーダルと同じ見た目)\n.close-icon-button {\n  width: 36px;\n  height: 36px;\n  min-height: 36px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--dark-color-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  font-family: inherit;\n  transition: background-color .2s, color .2s;\n\n  .bi {\n    font-size: 20px;\n\n    // アイコンを上下中央に揃える(運営ツールの .ops-scope と同じ指定)\n    &::before {\n      display: block;\n      line-height: 1;\n      vertical-align: 0;\n    }\n  }\n\n  &:hover {\n    background: var(--color-bg);\n    color: var(--primary-color-main);\n  }\n\n  &:disabled {\n    cursor: default;\n    color: var(--disabled-font-color);\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
